var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotFoundPage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "illustration",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 4798.255 3435.704",
    style: {
      enableBackground: "new 0 0 4798.255 3435.704"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    x: 0,
    y: 0,
    style: {
      fill: "#FFFFFF"
    },
    width: 4798.255,
    height: 3435.704
  }), /*#__PURE__*/React.createElement("g", {
    id: "die"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7EDF5"
    },
    d: "M987.81,3154.847c-159.982-31.126-299.458-151.745-353.336-305.565 c-53.878-153.819-20.149-335.106,85.446-459.255c39.169-46.052,86.814-84.074,128.852-127.523 c180.248-186.298,242.782-453.235,304.242-705.066c61.46-251.832,138.848-518.355,336.222-686.403 c134.348-114.388,317.038-170.017,492.338-149.917c336.433,38.575,580.706,323.189,853.428,523.932 c181.221,133.391,386.216,234.387,602.41,296.791c127.241,36.728,259.278,60.57,379.118,116.941 c225.254,105.957,390.932,329.717,426.55,576.085c49.602,343.097-136.799,671.341-316.237,967.952L987.81,3154.847z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7EDF5"
    },
    d: "M1060.95,1671.864c11.983-121.185-75.066-240.551-190.195-280.234 c-115.128-39.684-248.524-5.595-341.562,72.976c-101.178,85.445-157.389,224.072-135.843,354.738 c26.143,158.546,199.522,327.193,370.994,288.264C922.193,2071.772,1046.758,1815.389,1060.95,1671.864z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7EDF5"
    },
    d: "M3404.819,1375.335c142.752,33.798,303.031,16.865,419.718-72.043 c92.866-70.757,150.974-182.566,164.739-298.502c10.878-91.619-5.374-187.711-53.823-266.229 c-39.777-64.465-99.044-114.571-161.172-157.908c-108.883-75.951-231.74-135.23-362.986-155.197 c-131.245-19.966-271.531,2.014-381.529,76.341c-208.702,141.022-209.014,385.989-92.087,587.422 C3024.088,1238.079,3246.615,1337.879,3404.819,1375.335z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "plants"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M1639.731,2955.175l3.958,1.149c28.3-97.448,115.248-238.706,184.054-328.716l-3.273-2.502 C1755.437,2715.412,1668.183,2857.22,1639.731,2955.175z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M1627.828,3021.907l4.055,0.724c11.512-64.609,115.299-169.272,193.554-212.854l-2.002-3.597 C1744.406,2850.192,1639.533,2956.237,1627.828,3021.907z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#3A4254"
    },
    cx: 1841.004,
    cy: 2608.171,
    r: 33.957
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9912 -0.1323 0.1323 0.9912 -351.9828 268.6406)",
    style: {
      fill: "#3A4254"
    },
    cx: 1845.247,
    cy: 2782.622,
    rx: 33.416,
    ry: 33.417
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M3046.866,2994.073c53.491-159.823,133.542-307.956,237.923-440.28l1.817,1.433 c-104.216,132.115-184.138,280.011-237.546,439.583L3046.866,2994.073z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M3282.644,2555.361c1.889-15.074,4.125-30.997,13.63-42.849s28.957-17.085,39.98-6.631 c11.718,11.112,5.886,32.392-7.302,41.712s-30.437,9.977-46.585,9.979L3282.644,2555.361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M3246.636,2606.9c24.498-12.257,75.537-18.443,77.156,8.902 c1.767,29.833-61.047,18.633-78.126-5.892L3246.636,2606.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M3213.054,2654.367c27.858-10.99,84.035-12.813,83.166,17.122 c-0.948,32.658-68.274,14.414-84.512-13.937L3213.054,2654.367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M3182.365,2702.477c30.102-7.598,90.455-1.639,89.01,29.561 c-1.577,34.039-73.559,5.522-90.51-26.417L3182.365,2702.477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M3151.384,2761.905c31.636-6.07,96.398,3.977,96.82,36.594 c0.46,35.585-78.128,1.157-98.223-33.393L3151.384,2761.905z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M3120.227,2821.534c31.636-6.07,96.398,3.977,96.82,36.594 c0.46,35.585-78.128,1.157-98.223-33.393L3120.227,2821.534z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M3094.046,2878.621c28.207-5.496,85.444,3.271,85.085,32.323 c-0.391,31.695-69.348,1.25-86.402-29.468L3094.046,2878.621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M3246.504,2607.298c-2.711-27.259-24.722-73.721-48.711-60.494 c-26.171,14.43,16.828,61.569,46.683,62.921L3246.504,2607.298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M3212.453,2653.77c-5.576-29.424-34.019-77.902-58.869-61.189 c-27.111,18.233,24.253,65.429,56.895,64.027L3212.453,2653.77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M3182.231,2701.769c-9.642-29.511-46.896-77.367-72.508-59.491 c-27.942,19.502,34.594,65.151,70.65,62.438L3182.231,2701.769z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M3148.514,2759.689c-11.753-29.992-54.816-79.395-82.625-62.342 c-30.338,18.605,40.723,66.686,80.666,65.237L3148.514,2759.689z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M3120.638,2821.495c-11.753-29.992-54.816-79.395-82.625-62.342 c-30.338,18.604,40.723,66.685,80.666,65.237L3120.638,2821.495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M3092.257,2877.737c-10.408-26.786-48.374-70.508-72.75-54.698 c-26.594,17.249,35.959,59.311,71.037,57.335L3092.257,2877.737z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M1399.745,3161.667c52.558-160.132,131.743-308.73,235.35-441.66l1.826,1.423 c-103.443,132.721-182.501,281.081-234.977,440.962L1399.745,3161.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M1632.959,2721.587c1.802-15.085,3.944-31.021,13.379-42.927 c9.435-11.907,28.856-17.253,39.941-6.864c11.782,11.043,6.075,32.357-7.058,41.754s-30.378,10.154-46.526,10.251 L1632.959,2721.587z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M1597.252,2773.335c24.426-12.4,75.428-18.884,77.207,8.452 c1.94,29.823-60.938,18.989-78.159-5.436L1597.252,2773.335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M1563.948,2820.997c27.794-11.152,83.959-13.303,83.264,16.636 c-0.757,32.663-68.188,14.812-84.592-13.443L1563.948,2820.997z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M1533.541,2869.286c30.057-7.773,90.444-2.167,89.18,29.041 c-1.378,34.047-73.525,5.951-90.662-25.888L1533.541,2869.286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M1502.906,2928.893c31.6-6.255,96.42,3.414,97.032,36.029 c0.668,35.582-78.12,1.613-98.416-32.819L1502.906,2928.893z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M1472.098,2988.703c31.6-6.255,96.42,3.414,97.032,36.029 c0.668,35.582-78.12,1.613-98.416-32.819L1472.098,2988.703z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M1446.25,3045.941c28.174-5.66,85.462,2.773,85.273,31.827 c-0.206,31.697-69.34,1.655-86.572-28.963L1446.25,3045.941z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M1597.123,2773.734c-2.87-27.243-25.152-73.575-49.063-60.209 c-26.086,14.582,17.187,61.47,47.049,62.648L1597.123,2773.734z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M1563.343,2820.403c-5.748-29.391-34.473-77.702-59.225-60.844 c-27.004,18.391,24.634,65.286,57.267,63.694L1563.343,2820.403z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M1533.402,2868.579c-9.814-29.454-47.346-77.092-72.854-59.067 c-27.828,19.665,34.973,64.948,71.013,62.024L1533.402,2868.579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M1500.024,2926.694c-11.928-29.923-55.279-79.074-82.987-61.859 c-30.229,18.781,41.112,66.447,81.045,64.765L1500.024,2926.694z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M1472.508,2988.662c-11.928-29.923-55.279-79.074-82.987-61.859 c-30.229,18.781,41.112,66.447,81.045,64.765L1472.508,2988.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M1444.456,3045.068c-10.565-26.725-48.784-70.225-73.067-54.272 c-26.492,17.403,36.304,59.1,71.37,56.92L1444.456,3045.068z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M1236.062,3181.825c21.613-137.358,66.436-268.846,133.22-390.807l1.675,0.917 c-66.679,121.768-111.43,253.046-133.009,390.188L1236.062,3181.825z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M1367.753,2792.588c-0.529-12.523-0.893-25.783,5.216-36.728 c6.108-10.945,21.216-17.868,31.618-10.875c11.056,7.434,9.229,25.546-0.223,34.936c-9.452,9.39-23.395,12.288-36.533,14.504 L1367.753,2792.588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M1345.522,2839.454c18.251-13.33,58.926-25.358,63.992-3.333 c5.526,24.029-47.112,23.526-64.368,5.915L1345.522,2839.454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M1324.706,2882.674c21.158-12.759,66.612-21.942,70.008,2.531 c3.705,26.699-53.57,21.085-70.666,0.245L1324.706,2882.674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M1306.333,2926.021c23.449-10.307,73.367-13.731,76.467,11.85 c3.382,27.909-59.088,14.574-77.256-9.086L1306.333,2926.021z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M1289.272,2978.616c24.906-9.275,78.971-9.978,83.785,16.501 c5.252,28.888-63.404,11.65-84.488-13.705L1289.272,2978.616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M1272.098,3031.399c24.906-9.274,78.971-9.977,83.785,16.502 c5.252,28.887-63.404,11.65-84.488-13.705L1272.098,3031.399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M1258.622,3081.431c22.195-8.337,69.963-9.05,73.653,14.635 c4.026,25.84-56.248,10.522-74.332-12.132L1258.622,3081.431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M1345.469,2839.796c-5.942-21.805-30.218-56.588-47.921-42.54 c-19.314,15.327,22.13,47.784,46.604,44.792L1345.469,2839.796z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M1324.135,2882.27c-8.57-23.174-38.354-58.716-56.281-41.712 c-19.557,18.55,28.699,49.906,55.063,44.292L1324.135,2882.27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M1306.127,2925.464c-11.889-22.688-48.757-56.516-67.144-38.462 c-20.06,19.696,37.074,48.263,66.036,41.114L1306.127,2925.464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M1286.635,2977.207c-13.673-22.79-55.479-57.08-75.765-39.395 c-22.132,19.294,42.271,48.672,74.568,42.018L1286.635,2977.207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M1272.427,3031.311c-13.673-22.79-55.479-57.08-75.765-39.395 c-22.132,19.294,42.271,48.671,74.568,42.018L1272.427,3031.311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M1257.045,3080.957c-12.139-20.365-49.019-50.733-66.683-34.529 c-19.271,17.678,37.384,43.325,65.652,36.91L1257.045,3080.957z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M3207.14,3059.272c75.618-128.428,172.064-241.868,286.654-337.164l1.309,1.574 c-114.408,95.146-210.7,208.404-286.2,336.63L3207.14,3059.272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M3491.651,2723.071c4.402-12.693,9.26-26.056,19.658-34.563 c10.398-8.507,28.185-9.461,35.801,1.606c8.096,11.763-0.856,29.101-13.975,34.741s-28.161,3.041-42.13,0.078L3491.651,2723.071 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M3451.039,2761.042c23.442-6.104,68.728-2.083,65.107,21.868 c-3.95,26.131-56.229,4.908-66.499-19.442L3451.039,2761.042z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M3413.274,2795.935c26.116-4.391,75.045,4.347,68.796,30.082 c-6.817,28.076-61.705-0.068-70.546-27.574L3413.274,2795.935z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M3377.893,2831.916c27.434-1.045,78.547,15.192,71.567,41.915 c-7.615,29.154-64.644-8.731-73.442-39.471L3377.893,2831.916z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M3340.181,2877.633c28.48,0.558,82.656,21.141,77.032,49.433 c-6.136,30.866-67.795-13.345-78.833-46.921L3340.181,2877.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M3302.281,2923.493c28.48,0.558,82.656,21.141,77.032,49.433 c-6.136,30.866-67.795-13.345-78.833-46.921L3302.281,2923.493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M3269.151,2968.066c25.408,0.426,73.31,18.52,67.666,43.584 c-6.159,27.345-60.218-11.653-69.329-41.356L3269.151,2968.066z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M3450.852,2761.361c2.66-24.077-7.849-68.31-31.028-61.273c-25.288,7.677,3.251,56.349,28.828,63 L3450.852,2761.361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M3412.864,2795.308c0.579-26.476-15.123-73.634-39.688-63.74 c-26.799,10.794,8.965,61.05,37.458,65.832L3412.864,2795.308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M3377.907,2831.279c-2.922-27.298-26.359-75.535-51.797-64.775 c-27.752,11.739,17.961,62.709,49.649,66.983L3377.907,2831.279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M3338.106,2875.19c-4.659-28.102-32.839-78.744-60.025-69.099 c-29.659,10.523,22.981,65.162,57.799,71.243L3338.106,2875.19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M3302.643,2923.535c-4.659-28.102-32.839-78.744-60.025-69.099 c-29.659,10.523,22.981,65.162,57.799,71.243L3302.643,2923.535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AF98"
    },
    d: "M3267.766,2966.973c-4.085-25.081-28.897-69.874-52.886-60.673 c-26.171,10.037,20.214,57.908,50.921,62.641L3267.766,2966.973z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M2918.136,2990.284l-2.831-0.948c45.396-135.399,124.67-258.366,229.249-355.607l2.035,2.189 C3042.372,2732.818,2963.375,2855.356,2918.136,2990.284z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7732 -0.6342 0.6342 0.7732 -946.1717 2600.2825)",
    style: {
      fill: "#3A4254"
    },
    cx: 3162.141,
    cy: 2622.901,
    rx: 35.501,
    ry: 35.501
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M2839.406,2999.04l-2.983,0.125c-5.887-142.685,24.308-285.84,87.322-413.989l2.683,1.319 C2863.629,2714.195,2833.539,2856.851,2839.406,2999.04z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4961 -0.8683 0.8683 0.4961 -739.4019 3829.8027)",
    style: {
      fill: "#3A4254"
    },
    cx: 2929.877,
    cy: 2551.935,
    rx: 35.501,
    ry: 35.501
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M2861.682,3045.877l-3.218-2.432c77.9-103.283,117.479-236.538,108.59-365.599l4.026-0.276 C2980.037,2807.586,2940.164,2941.828,2861.682,3045.877z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -1006.9733 2875.3157)",
    style: {
      fill: "#3A4254"
    },
    cx: 2967.326,
    cy: 2653.182,
    rx: 38.065,
    ry: 38.065
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#647C65"
    },
    d: "M1511.433,3185.569c32.857,0,65.714,0,98.57,0c394.076,0,788.152,0,1182.228,0 c210.269,0,420.537,0,630.806,0c91.3,0,307.081,2.474,345.983,0.043c-27.481-85.711-34.798-165.748-129.808-215.068 c-72.039-37.395-160.031-32.974-236.728-6.411c-76.699,26.563-144.556,73.215-211.357,119.324 c65.425-3.56,96.989-96.388,59.592-150.188c-37.398-53.8-115.207-66.036-177.586-45.987 c-62.378,20.049-112.977,65.221-161.549,109.196c21.162-60.598,133.038-143.501,80.245-218.917 c-19.911-28.444-60.834-30.309-95.413-27.184c-87.245,7.885-165.603,41.348-253.133,102.133 c-74.951,52.049-169.483,95.255-238.725,155.468c30.766-32.717,62.766-67.703,72.408-111.566 c9.642-43.863-13.214-98.186-57.459-105.886c-38.628-6.722-73.643,22.939-98.788,53.024 c-46.967,56.193-82.541,121.869-103.946,191.908c40.266-131.336,101.713-357.869-35.456-365.302 c-84.351-4.571-174.181,127.714-200.777,207.892c-26.597,80.178-65.211,167.362-143.762,198.437 c13.66-27.708,27.584-56.39,29.214-87.239c1.629-30.849-12.282-64.711-40.64-76.962c-33.786-14.597-96.657-11.177-127.882,8.306 c-93.335,58.238-161.694,133.195-255.029,191.432c42.83-10.939,38.693-81.316,0.678-103.875 c-38.016-22.558-86.52-11.209-128.14,3.684c-97.109,34.748-144.65,109.565-225.358,173.781c104.55-2.431,131.175-3.245,226.12,0 C1378.971,3187.786,1448.196,3183.494,1511.433,3185.569z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1238.135,
    y: 3096.992,
    transform: "matrix(0.7556 -0.6551 0.6551 0.7556 -1705.8036 1624.767)",
    style: {
      fill: "#656F40"
    },
    width: 172.393,
    height: 2.431
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#405240"
    },
    d: "M1521.775,3164.823l-1.254-2.085c84.889-51.083,160.602-120.41,218.953-200.482l1.966,1.432 C1682.898,3044.021,1606.939,3113.572,1521.775,3164.823z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#405240"
    },
    d: "M2639.054,3067.876l-2.375-0.522c13.876-63.213,49.051-123.75,99.046-170.458 c49.996-46.707,112.78-77.69,176.789-87.241l0.361,2.405c-63.527,9.478-125.851,40.238-175.49,86.613 C2687.746,2945.048,2652.825,3005.138,2639.054,3067.876z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#405240"
    },
    d: "M2992.298,3090.823l-2.142-1.149c34.799-65.019,80.283-122.952,135.187-172.189l1.624,1.809 C3072.275,2968.342,3026.964,3026.052,2992.298,3090.823z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#405240"
    },
    d: "M3030.697,3105.086l-0.855-2.275c61.564-23.177,118.581-56.064,169.467-97.75l1.539,1.881 C3149.757,3048.795,3092.51,3081.816,3030.697,3105.086z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#405240"
    },
    d: "M3314.634,3147.877l-1.648-1.79c61.915-57.036,136.308-102.795,215.136-132.334l0.855,2.277 C3450.438,3045.459,3376.319,3091.05,3314.634,3147.877z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#405240"
    },
    d: "M3423.928,3144.306l-0.807-2.294c55.898-19.715,108.758-47.094,157.11-81.378l1.406,1.985 C3533.101,3097.031,3480.04,3124.515,3423.928,3144.306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#405240"
    },
    d: "M2006.511,3100.648l-1.774-1.662c81.481-86.848,140.056-193.757,169.392-309.167l2.355,0.598 C2147.049,2906.226,2088.273,3013.502,2006.511,3100.648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#656F40"
    },
    d: "M2319.422,3137.271l-2.398-0.413c13.639-79.087,39.669-155.112,77.365-225.967l2.146,1.142 C2358.961,2982.658,2333.016,3058.44,2319.422,3137.271z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "clouds"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6E1F0"
    },
    d: "M1579.336,1227.122c-22.589,11.8-53.291,9.544-75.214-3.12 c-26.565,33.073-74.083,53.296-121.321,51.626c-47.23-1.671-92.595-25.17-115.8-60.006 c3.402,28.126-45.652,96.056-132.759,110.547c-51.493,8.566-120.266-5.611-159.941-33.622 c-41.811,67.887-289.99,121.426-359.987-15.969c-43.221,11.643-95.364,6.86-126.707-20.873 c-13.591-12.029-21.078-28.668-21.999-45.187c-0.869-15.619,10.805-35.078,15.988-42.881c1.46-2.199,2.406-3.476,2.406-3.476 s-57.216-27.148-30.026-81.393c3.039-6.075,7.496-11.315,12.958-15.712c20.099-16.212,53.874-21.094,81.494-14.491 c-11.404-38.205,13.354-81.829,55.739-98.205c42.385-16.383,97.583-3.655,124.284,28.64 c35.581-69.272,126.588-115.094,215.553-108.541c88.973,6.553,169.243,64.989,190.128,138.416 c20.428-20.109,55.503-28.568,85.402-20.602c18.2,4.847,33.842,15.612,44.005,29.239c6.525,8.766,10.78,18.71,11.995,29.039 c23.121-14.869,57.934-22.879,89.184-20.68c12.181,0.864,23.822,3.27,34.019,7.424c36.366,14.834,52.709,51.233,53.587,85.362 c4.989-25.998,52.894-39.405,74.167-20.159c16.908,15.291,16.883,27.598,8.239,50.219c21.34-13.349,55.756-4.404,67.101,15.89 C1613.186,1188.902,1601.925,1215.322,1579.336,1227.122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6E1F0"
    },
    d: "M1482.318,611.934c-5-32.047,26.78-64.968,70.038-72.554c43.258-7.586,92.294,11.163,108.069,41.32 c13.402-16.159,42.195-24.699,67.385-19.986c25.191,4.712,44.681,22.284,45.615,41.125c27.414-17.903,88.856,26.146,40.487,57.407 c14.38,29.84-53.598,74.362-105.339,27.945c-23.427,52.574-142.389,73.218-190.759,42.871 c-21.041-13.202-36.604-47.133-36.604-47.133C1420.422,688.138,1415.193,617.565,1482.318,611.934z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6E1F0"
    },
    d: "M3577.936,1341.605c-3.909-13.746,12.077-40.534,27.621-50.212 c15.544-9.677,36.029-13.547,55.507-14.212c-15.106-26.64-15.456-59.114,3.17-86.843c18.626-27.729,57.253-49.483,97.878-51.93 c40.624-2.447,80.379,16.428,88.865,44.993c8.363-30.638,23.817-61.589,52.509-85.867c28.692-24.278,72.434-40.769,113.234-36.658 c40.801,4.11,74.014,32.491,66.451,63.189c34.925-22.761,77.186-40.837,121.828-44.822c44.641-3.985,91.382,8.207,113.16,35.336 c21.778,27.129,11.672,69.016-26.631,88.433c30.573-7.559,67.462-17.259,92.739-5.198 c151.474,72.272-30.865,295.646-233.999,174.408c-25.496,39.545-76.091,68.89-129.743,87.752 c-45.189,15.887-96.603,25.54-141.816,15.778c-45.213-9.762-80.16-43.703-68.61-78.997c-3.681,11.249-57.941,32.604-89.709,21.445 c-45.882-16.116-35.494-53.896-35.494-53.896s-28.366,12.633-50.521,12.452C3610.734,1376.564,3585.472,1368.106,3577.936,1341.605 z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "floor",
    style: {
      fill: "#B5CBE5"
    },
    cx: 2449.507,
    cy: 3180.587,
    rx: 1907.466,
    ry: 44.325
  }), /*#__PURE__*/React.createElement("g", {
    id: "window"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCDAEB"
    },
    d: "M3820.49,866.726v1388.223c0,49.353-40.007,89.369-89.36,89.369H1067.125 c-49.353,0-89.36-40.017-89.36-89.369V866.726c0-49.353,40.007-89.369,89.36-89.369h2664.006 C3780.483,777.357,3820.49,817.374,3820.49,866.726z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B5CBE5"
    },
    d: "M3713.876,777.357v1363.821c0,49.353-40.007,89.369-89.36,89.369H977.765V866.726 c0-49.353,40.007-89.369,89.36-89.369H3713.876z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M3820.49,866.726v63.116H977.765v-63.116c0-49.353,40.007-89.369,89.36-89.369h2664.006 C3780.483,777.357,3820.49,817.374,3820.49,866.726z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M1369.796,786.36c-4.971,0-9-4.029-9-9V330.962c0-4.971,4.029-9,9-9s9,4.029,9,9V777.36 C1378.796,782.331,1374.766,786.36,1369.796,786.36z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M3428.46,786.36c-4.971,0-9-4.029-9-9V330.962c0-4.971,4.029-9,9-9s9,4.029,9,9V777.36 C3437.46,782.331,3433.43,786.36,3428.46,786.36z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 3367.041,
    cy: 853.6,
    r: 31.52
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 3511.836,
    cy: 853.6,
    r: 31.52
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 3656.633,
    cy: 853.6,
    r: 31.52
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1972.028,1217.028h134.439v360.47h59.75v87.661h-59.75v110.46h-114.785v-110.46H1786.88v-110.067 L1972.028,1217.028z M1994.828,1347.143l-119.894,230.355h119.894V1347.143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2396.573,1207.202c58.965,0,104.299,24.832,136.011,74.491 c31.706,49.665,47.564,121.141,47.564,214.434c0,92.771-15.92,164.057-47.761,213.845 c-31.841,49.794-77.115,74.688-135.815,74.688c-59.493,0-104.828-24.697-136.012-74.099 c-31.189-49.395-46.779-120.877-46.779-214.434c0-94.079,15.589-165.752,46.779-215.024 C2291.744,1231.837,2337.08,1207.202,2396.573,1207.202z M2397.358,1301.544c-21.756,0-37.412,15.005-46.974,45.01 c-9.57,30.01-14.349,79.867-14.349,149.573c0,69.713,4.779,119.501,14.349,149.377c9.563,29.875,25.219,44.813,46.974,44.813 c21.485,0,37.013-15.134,46.583-45.402c9.563-30.268,14.348-79.86,14.348-148.787c0-68.921-4.785-118.58-14.348-148.984 C2434.371,1316.746,2418.844,1301.544,2397.358,1301.544z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2817.186,1217.028h134.439v360.47h59.75v87.661h-59.75v110.46h-114.785v-110.46h-204.802 v-110.067L2817.186,1217.028z M2839.986,1347.143l-119.894,230.355h119.894V1347.143z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2214.975,2072.271h-102.062v-157.062h101.026v23.358h-72.72v42.574h58.452v22.782h-58.452 v43.955h73.756V2072.271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2361.796,2072.271h-29.917l-24.394-64.551h-39.812v64.551h-28.306v-157.062h68.118 c18.946,0,32.869,4.277,41.768,12.83c8.897,8.554,13.348,19.618,13.348,33.196c0,20.176-9.436,34.059-28.306,41.653 L2361.796,2072.271z M2267.674,1985.053h35.209c10.201,0,17.795-2.147,22.783-6.444c4.985-4.295,7.479-10.201,7.479-17.72 c0-6.904-2.456-12.484-7.364-16.742c-4.91-4.257-11.776-6.386-20.596-6.386h-37.511V1985.053z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2513.22,2072.271h-29.917l-24.394-64.551h-39.812v64.551h-28.306v-157.062h68.117 c18.946,0,32.869,4.277,41.769,12.83c8.897,8.554,13.348,19.618,13.348,33.196c0,20.176-9.436,34.059-28.306,41.653 L2513.22,2072.271z M2419.098,1985.053h35.209c10.201,0,17.796-2.147,22.783-6.444c4.985-4.295,7.479-10.201,7.479-17.72 c0-6.904-2.455-12.484-7.363-16.742c-4.91-4.257-11.776-6.386-20.597-6.386h-37.511V1985.053z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2598.022,2074.687c-20.866,0-37.108-7.824-48.729-23.473s-17.433-34.979-17.433-57.992 c0-22.858,6.174-41.979,18.525-57.359c12.35-15.379,28.651-23.07,48.902-23.07c20.404,0,36.533,7.691,48.385,23.07 c11.852,15.381,17.777,34.616,17.777,57.705c0,24.241-6.156,43.822-18.468,58.74 C2634.67,2067.228,2618.349,2074.687,2598.022,2074.687z M2598.253,2051.905c10.201,0,18.83-4.218,25.889-12.657 c7.057-8.438,10.586-23.741,10.586-45.91c0-18.026-2.916-32.161-8.744-42.401c-5.831-10.241-14.883-15.361-27.155-15.361 c-24.241,0-36.36,19.523-36.36,58.567c0,18.948,3.087,33.311,9.263,43.091 C2577.904,2047.014,2586.746,2051.905,2598.253,2051.905z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2814.227,2072.271h-29.917l-24.394-64.551h-39.812v64.551H2691.8v-157.062h68.117 c18.946,0,32.869,4.277,41.769,12.83c8.897,8.554,13.348,19.618,13.348,33.196c0,20.176-9.436,34.059-28.306,41.653 L2814.227,2072.271z M2720.105,1985.053h35.209c10.201,0,17.796-2.147,22.783-6.444c4.985-4.295,7.479-10.201,7.479-17.72 c0-6.904-2.455-12.484-7.363-16.742c-4.91-4.257-11.776-6.386-20.597-6.386h-37.511V1985.053z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "barrier"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2253.282,
    y: 2201.882,
    style: {
      fill: "#3A4254"
    },
    width: 1737.267,
    height: 293.535
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EEBE58"
    },
    points: "2605.357,2201.882 2311.822,2495.417 2253.282,2495.417 2253.282,2357.374  2408.775,2201.882  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EEBE58"
    },
    points: "3110.902,2201.882 2817.367,2495.417 2620.8,2495.417 2914.334,2201.882  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EEBE58"
    },
    points: "3616.454,2201.882 3322.919,2495.417 3126.344,2495.417 3419.879,2201.882  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EEBE58"
    },
    points: "3990.549,2201.882 3990.549,2333.339 3828.471,2495.417 3631.897,2495.417  3925.432,2201.882  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2253.282,
    y: 2201.882,
    style: {
      opacity: 0.16,
      fill: "#FFFFFF"
    },
    width: 1737.267,
    height: 76.262
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2357.279,
    y: 2495.415,
    style: {
      fill: "#3A4254"
    },
    width: 55.815,
    height: 668.427
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3808.714,
    y: 2495.415,
    style: {
      fill: "#3A4254"
    },
    width: 55.805,
    height: 668.427
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2357.279,
    y: 2495.415,
    style: {
      fill: "#283041"
    },
    width: 55.815,
    height: 94.168
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3808.714,
    y: 2495.415,
    style: {
      fill: "#283041"
    },
    width: 55.805,
    height: 94.168
  })))), /*#__PURE__*/React.createElement("g", {
    id: "man"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6ADA1"
    },
    d: "M1490.444,3100.045c0.596-13.369,4.115-68.026,1.688-70.437 c-1.918-1.906-32.519-10.847-48.384-9.641c-7.149,0.544-40.941-7.942-47.626-5.346c-3.739,1.452,4.381,29.649,4.652,58.73 c0.05,5.401-2.654,28.137-2.668,33.332c12.438,0.152,33.351-15.833,45.901-15.36 C1456.539,3091.794,1478.114,3097.758,1490.444,3100.045z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1465.884,3077.025c-5.947-2.852-12.419-3.341-18.971-4.431 c-12.168-2.024-25.138,5.184-33.859,14.227c-3.717,3.855-9.978,8.337-12.098,13.255l-19.911,46.174 c-2.105,4.882-4.133,10.75-1.067,15.15c3.089,4.434,9.601,4.877,15.169,4.866c44.085-0.09,80.182,1.56,124.266,1.47 c4.992-14.198,2.534-30.497-7.298-42.179c-9.66-11.477-18.916-23.453-29.066-34.535 C1475.308,3082.57,1475.518,3082.401,1465.884,3077.025z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M1380.794,3179.518c0.96,4.233,4.667,7.271,9.006,7.376c15.73,0.38,50.97,1.209,65.963,1.376 c13.517,0.15,42.466-2.562,56.478-3.968c4.519-0.454,7.975-4.22,8.045-8.761l0.279-17.937c-0.018,1.139-46.803-1.064-52.06-1.343 c-21.322-1.129-30.025-4.546-55.123-3.226c-7.994,0.42-34.924,4.037-35.047,7.838 C1378.224,3164.283,1379.257,3172.744,1380.794,3179.518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M1421.026,3102.911c-0.31,0-0.616-0.136-0.823-0.397c-0.362-0.454-0.287-1.116,0.168-1.478 c13.535-10.782,34.014-11.955,48.692-2.788c0.493,0.308,0.643,0.957,0.335,1.45c-0.308,0.492-0.957,0.643-1.45,0.335 c-13.947-8.71-33.406-7.597-46.267,2.649C1421.487,3102.836,1421.255,3102.911,1421.026,3102.911z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M1426.757,3117.075c-0.433,0-0.839-0.27-0.992-0.702c-0.193-0.548,0.094-1.148,0.642-1.342 c14.625-5.164,30.76-5.244,45.436-0.228c0.55,0.188,0.844,0.786,0.655,1.336s-0.789,0.841-1.335,0.655 c-14.231-4.863-29.875-4.785-44.056,0.221C1426.991,3117.056,1426.873,3117.075,1426.757,3117.075z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M1445.495,3093.145l-1.537-1.135c-1.623-1.198-15.914-11.821-18.128-15.718 c-1.433-2.523-3.234-6.315-2.333-10.103c1.103-4.631,6.315-7.834,11.389-6.992c4.39,0.729,8.401,4.246,10.217,8.961 c1.829,4.747,0.583,22.335,0.529,23.081L1445.495,3093.145z M1427.659,3075.253c1.513,2.664,10.958,10.104,16,13.907 c0.347-5.909,0.708-17.062-0.518-20.245c-1.554-4.034-4.93-7.034-8.599-7.642c-3.949-0.657-8.157,1.87-8.998,5.404 C1424.814,3069.743,1426.402,3073.04,1427.659,3075.253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M1445.866,3092.543l-0.491-0.928c-0.094-0.177-2.285-4.389-1.427-8.898 c0.225-1.179,0.358-2.319,0.487-3.421c0.347-2.972,0.675-5.778,2.677-8.63l0,0c4.752-6.768,12.863-10.204,19.727-8.35 c3.233,0.872,5.584,2.881,6.289,5.373c0.814,2.877-0.418,5.972-3.768,9.46c-5.78,6.022-21.882,14.545-22.565,14.905 L1445.866,3092.543z M1448.834,3071.875c-1.697,2.416-1.981,4.848-2.31,7.666c-0.133,1.139-0.271,2.317-0.51,3.57 c-0.497,2.608,0.269,5.191,0.794,6.547c3.645-1.979,16.287-9.02,21.033-13.965c2.788-2.904,3.854-5.334,3.261-7.43 c-0.502-1.774-2.301-3.237-4.813-3.915C1460.266,3062.723,1453.088,3065.817,1448.834,3071.875L1448.834,3071.875z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.52,
      fill: "#7F413C"
    },
    points: "1492.132,3055.781 1398.189,3042.31 1492.132,3022.671  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6ADA1"
    },
    d: "M1244.537,3101.146c-0.608-13.628,4.556-39.154,4.682-42.639 c1.449-40.129,20.203-56.245,36.376-55.015c7.288,0.554,46.986,16.261,53.801,18.907c3.811,1.48,1.182,30.394-0.55,47.762 c-0.546,5.479-4.843,22.562-4.829,27.858c-12.68,0.154-29.349-6.246-42.142-5.765 C1279.1,3092.735,1257.107,3098.815,1244.537,3101.146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1269.574,3077.679c6.062-2.907,12.66-3.406,19.339-4.517 c12.404-2.063,25.626,5.285,34.516,14.503c3.789,3.93,10.172,8.499,12.333,13.512l20.297,47.07 c2.146,4.977,4.213,10.959,1.088,15.445c-3.149,4.52-9.787,4.972-15.464,4.96c-44.941-0.092-81.738,1.59-126.679,1.499 c-5.089-14.474-2.583-31.089,7.44-42.998c9.848-11.7,19.283-23.908,29.63-35.205 C1259.967,3083.332,1259.753,3083.16,1269.574,3077.679z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M1356.317,3182.162c-0.979,4.315-4.757,7.412-9.18,7.519c-16.035,0.387-51.96,1.233-67.244,1.402 c-13.779,0.153-43.29-2.611-57.574-4.045c-4.607-0.462-8.129-4.302-8.202-8.931l-0.285-18.286 c0.018,1.161,47.711-1.085,53.071-1.369c21.736-1.152,30.608-4.634,56.193-3.289c8.149,0.428,35.602,4.115,35.728,7.99 C1358.936,3166.632,1357.883,3175.257,1356.317,3182.162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M1315.303,3104.068c0.316,0,0.628-0.139,0.839-0.405c0.37-0.463,0.293-1.138-0.171-1.507 c-13.798-10.991-34.674-12.187-49.638-2.842c-0.502,0.314-0.655,0.975-0.341,1.478c0.314,0.502,0.976,0.655,1.478,0.341 c14.218-8.88,34.055-7.744,47.165,2.7C1314.833,3103.992,1315.069,3104.068,1315.303,3104.068z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M1309.461,3118.507c0.442,0,0.856-0.275,1.011-0.716c0.197-0.558-0.096-1.171-0.655-1.368 c-14.909-5.264-31.358-5.346-46.318-0.233c-0.561,0.192-0.86,0.801-0.668,1.362c0.192,0.56,0.804,0.857,1.361,0.668 c14.507-4.958,30.455-4.878,44.911,0.225C1309.222,3118.488,1309.343,3118.507,1309.461,3118.507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M1290.219,3092.17c-0.055-0.761-1.326-18.69,0.539-23.53c1.852-4.807,5.94-8.393,10.415-9.135 c5.172-0.859,10.486,2.407,11.61,7.128c0.919,3.862-0.917,7.728-2.378,10.299c-2.257,3.972-16.826,14.801-18.48,16.022 l-1.567,1.157L1290.219,3092.17z M1310.697,3067.13c-0.857-3.602-5.147-6.178-9.173-5.508c-3.74,0.62-7.181,3.678-8.765,7.79 c-1.25,3.246-0.881,14.615-0.528,20.638c5.14-3.877,14.767-11.461,16.31-14.177 C1309.823,3073.617,1311.441,3070.256,1310.697,3067.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M1289.034,3092.999c-0.696-0.367-17.111-9.055-23.003-15.194 c-3.414-3.556-4.671-6.711-3.841-9.644c0.719-2.541,3.116-4.588,6.411-5.478c6.997-1.89,15.265,1.613,20.109,8.512l0,0 c2.042,2.908,2.375,5.769,2.729,8.798c0.132,1.124,0.267,2.285,0.497,3.487c0.875,4.597-1.36,8.89-1.455,9.071l-0.501,0.946 L1289.034,3092.999z M1286.955,3072.429c-4.336-6.175-11.654-9.329-17.795-7.674c-2.56,0.691-4.394,2.183-4.906,3.991 c-0.604,2.137,0.482,4.615,3.324,7.575c4.838,5.041,17.726,12.219,21.442,14.236c0.536-1.382,1.317-4.015,0.81-6.674 c-0.243-1.277-0.384-2.478-0.52-3.639C1288.975,3077.371,1288.685,3074.892,1286.955,3072.429L1286.955,3072.429z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.52,
      fill: "#7F413C"
    },
    points: "1339.722,3061.011 1250.482,3044.924 1341.353,3029.354  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M1579.164,2212.656c-9.704,337.411-51.716,827.313-51.716,827.313l-142.677,2.586l-38.905,0.662 l-169.803,3.037c-5.153-50.433-32.94-534.871-48.488-833.598l-0.02-0.441l-9.994-231.152l148.15-20.831h310.786 c0.411,4.09,0.782,8.36,1.133,12.811c1.103,14.024,1.925,29.802,2.496,47.105 C1581.86,2072.594,1581.279,2138.986,1579.164,2212.656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M1117.561,1981.062l9.994,231.152c-6.426-123.37-10.746-214.973-10.516-231.082L1117.561,1981.062z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M1576.498,1960.231h-310.786l303.609-42.684 C1572.327,1927.732,1574.693,1942.177,1576.498,1960.231z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1B1C23"
    },
    points: "1362.807,2152.796 1384.767,3042.553 1345.87,3043.214 1362.807,2152.796  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3A4254"
    },
    points: "1116.659,1960.231 1265.711,1960.231 1117.561,1981.062  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1C23"
    },
    d: "M1221.265,2012.803c-8.613-0.414-17.005-1.469-24.163-3.971 C1202.221,2007.028,1212.559,2010.13,1221.265,2012.803z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1C23"
    },
    d: "M1580.126,2020.147c-1.022,0.21-2.045,0.411-3.047,0.591c-28.058,5.123-56.377,8.872-84.806,11.257 c-49.911,4.19-100.174,4.18-150.085-0.01c-24.63-2.065-49.19-5.153-73.569-9.252c-12.51-2.095-24.971-4.471-37.371-7.097 c-2.626-0.561-6.145-1.654-9.984-2.837c10.886,0.521,22.134,0.03,31.717,0.12c66.341,0.661,132.081-10.265,197.32-21.152 c33.431-5.583,66.863-11.157,100.294-16.741c8.892-1.484,18.174-2.927,27.036-1.985 C1578.733,1987.067,1579.555,2002.845,1580.126,2020.147z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1597.879,1961.24c0.749,8.42,1.191,13.746,1.191,14.816c0,7.308-126.17,48.383-242.123,45.253 c-115.953-3.137-240.498-17.048-248.854-28.541c-1.169-1.611-1.419-7.479-0.984-16.42c0.021-0.963,0.086-1.946,0.15-2.966 c3.465-58.315,31.129-225.012,31.129-225.012l-74.115-102.297c0,0,60.533-218.448,72.026-233.178 c6.103-7.836,50.579-24.106,97.508-39.713c1.041-0.335,2.089-0.692,3.13-1.048c40.383-13.347,82.008-26.031,102.021-32.256 c17.775-5.497,40.177-9.447,64.183-11.657c1.041-0.107,2.11-0.193,3.173-0.292c35.706-3.052,74.628-2.367,107.098,2.545 c55.363,8.356,64.761,22.98,89.836,82.421c22.288,52.861-9.091,162.148-20.748,204.792c0,0.021-0.021,0.057-0.043,0.1 c-1.397,5.269-2.524,9.511-3.237,12.499c-1.547,6.709-2.524,14.887-3.094,23.792c-1.754,27.129,0.214,61.003,1.005,80.667 c0.036,0.884,0.093,1.982,0.178,3.273c0.021,0.428,0.05,0.877,0.086,1.355c0.442,6.652,1.34,17.468,2.531,30.901 c0.071,0.87,0.15,1.754,0.228,2.652c0.135,1.512,0.271,3.059,0.413,4.634c0.235,2.552,0.47,5.169,0.713,7.857 c0.884,9.682,1.861,20.206,2.888,31.186c4.791,51.143,10.723,112.025,13.44,141.649 C1597.686,1959.301,1597.772,1960.277,1597.879,1961.24z"
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M1584.161,1816.595c6.434,68.632,14.917,154.793,14.917,159.452c0,7.313-126.19,48.391-242.143,45.257 c-115.953-3.134-240.474-17.052-248.831-28.543c-8.357-11.491,30.294-244.401,30.294-244.401s-81.793-100.23-73.436-115.9 c8.357-15.669,59.856-204.842,71.347-219.571c11.491-14.729,158.804-59.418,202.657-73.019 c44.877-13.893,119.087-17.759,174.453-9.402c55.365,8.357,64.767,22.982,89.838,82.421 c22.292,52.858-9.109,162.147-20.746,204.788c0,0.021-0.021,0.063-0.042,0.104c-1.421,5.265-2.549,9.506-3.238,12.494 c-6.268,27.16-3.134,78.347-2.089,104.463C1577.517,1744.203,1580.505,1777.568,1584.161,1816.595z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000066508940279829663130000001165004016026869380_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000066508940279829663130000001165004016026869380_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M1099.701,1943.208c-2.424,0-4.846-0.924-6.694-2.774c-3.696-3.698-3.696-9.692,0.002-13.386 c16.26-16.253,41.786-22.254,63.52-14.932c4.955,1.67,7.618,7.037,5.948,11.992c-1.668,4.953-7.029,7.618-11.992,5.948 c-15.088-5.081-32.802-0.907-44.092,10.379C1104.545,1942.284,1102.123,1943.208,1099.701,1943.208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M1359.907,1999.107c-21.282,0-42.292-11.633-53.391-29.965 c-2.707-4.472-1.276-10.292,3.196-13.001c4.47-2.702,10.292-1.278,13.001,3.196c8.288,13.69,24.508,21.999,40.366,20.71 c5.176-0.42,9.781,3.446,10.209,8.657c0.428,5.211-3.448,9.781-8.657,10.209 C1363.059,1999.043,1361.481,1999.107,1359.907,1999.107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M1267.762,1817.047c-3.663,0-7.151-2.139-8.696-5.718c-9.109-21.11-5.392-47.173,9.251-64.853 c3.335-4.029,9.303-4.589,13.327-1.252c4.026,3.333,4.587,9.301,1.252,13.327c-10.218,12.34-12.81,30.535-6.446,45.277 c2.07,4.8-0.141,10.37-4.942,12.442C1270.286,1816.797,1269.014,1817.047,1267.762,1817.047z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M1134.318,1411.207c-2.11-1.188-3.769-3.183-4.472-5.7c-1.406-5.036,1.535-10.259,6.569-11.665 c22.142-6.181,47.329,1.109,62.676,18.158c3.499,3.884,3.184,9.87-0.702,13.368c-3.885,3.501-9.868,3.181-13.368-0.702 c-10.651-11.827-28.136-16.888-43.511-12.59C1138.992,1412.779,1136.428,1412.395,1134.318,1411.207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M1295.036,1531.774c-2.422,0-4.846-0.924-6.694-2.772c-3.696-3.698-3.696-9.692,0-13.388 c16.255-16.251,41.783-22.254,63.522-14.932c4.955,1.667,7.618,7.037,5.948,11.992c-1.668,4.955-7.037,7.618-11.992,5.948 c-15.086-5.081-32.802-0.913-44.09,10.379C1299.88,1530.85,1297.458,1531.774,1295.036,1531.774z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M1040.074,1778.672c-21.282,0-42.294-11.636-53.395-29.967 c-2.709-4.472-1.278-10.292,3.194-12.999c4.47-2.711,10.294-1.278,12.999,3.194c8.294,13.69,24.495,22.021,40.37,20.712 c5.174-0.413,9.781,3.446,10.207,8.659c0.428,5.209-3.448,9.781-8.659,10.207 C1043.22,1778.609,1041.646,1778.672,1040.074,1778.672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M1061.408,1579.21c-3.663,0-7.151-2.139-8.696-5.718c-9.109-21.108-5.392-47.171,9.249-64.852 c3.335-4.031,9.305-4.585,13.329-1.255c4.026,3.335,4.587,9.303,1.254,13.329c-10.22,12.34-12.812,30.535-6.448,45.277 c2.07,4.8-0.141,10.37-4.942,12.442C1063.932,1578.96,1062.66,1579.21,1061.408,1579.21z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M1466.279,1890.459c-2.424,0-4.846-0.924-6.694-2.774c-3.696-3.696-3.696-9.69,0.002-13.386 c16.258-16.251,41.781-22.254,63.52-14.932c4.955,1.667,7.618,7.037,5.948,11.992c-1.668,4.957-7.035,7.616-11.992,5.948 c-15.084-5.081-32.802-0.909-44.092,10.379C1471.123,1889.535,1468.701,1890.459,1466.279,1890.459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M1736.472,1931.192c-21.282,0-42.294-11.636-53.395-29.967 c-2.709-4.472-1.278-10.292,3.194-12.999c4.47-2.709,10.292-1.278,12.999,3.194c8.292,13.69,24.476,22.017,40.37,20.712 c5.185-0.42,9.783,3.446,10.207,8.659c0.428,5.209-3.448,9.781-8.659,10.207 C1739.618,1931.129,1738.044,1931.192,1736.472,1931.192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M1370.143,1393.879c-21.28,0-42.292-11.636-53.393-29.963 c-2.709-4.472-1.278-10.292,3.192-13.001c4.47-2.709,10.292-1.278,13.001,3.192c8.292,13.69,24.489,22.015,40.37,20.712 c5.177-0.428,9.781,3.446,10.207,8.659c0.428,5.209-3.448,9.781-8.659,10.207 C1373.292,1393.816,1371.718,1393.879,1370.143,1393.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M1502.883,1355.275c-3.663,0-7.151-2.139-8.696-5.718c-9.107-21.108-5.39-47.171,9.251-64.855 c3.335-4.031,9.305-4.585,13.329-1.254c4.026,3.335,4.587,9.303,1.254,13.329c-10.22,12.342-12.812,30.537-6.45,45.279 c2.07,4.8-0.141,10.37-4.942,12.442C1505.407,1355.025,1504.135,1355.275,1502.883,1355.275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M1196.872,1643.432c-2.422,0-4.846-0.924-6.694-2.772c-3.696-3.698-3.696-9.692,0-13.388 c16.255-16.251,41.781-22.254,63.522-14.932c4.955,1.668,7.618,7.038,5.948,11.992c-1.667,4.957-7.037,7.618-11.992,5.948 c-15.084-5.079-32.8-0.911-44.09,10.379C1201.716,1642.508,1199.294,1643.432,1196.872,1643.432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M1584.152,1548.862c-2.422,0-4.846-0.924-6.694-2.772c-3.696-3.698-3.696-9.692,0-13.388 c16.256-16.253,41.781-22.254,63.522-14.931c4.955,1.667,7.618,7.037,5.948,11.992c-1.667,4.957-7.04,7.616-11.992,5.948 c-15.086-5.081-32.802-0.911-44.09,10.379C1588.995,1547.938,1586.573,1548.862,1584.152,1548.862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M1479.112,1648.502c-21.282,0-42.297-11.636-53.395-29.967 c-2.707-4.472-1.276-10.292,3.196-13.001c4.47-2.702,10.29-1.276,13.001,3.196c8.288,13.688,24.465,21.997,40.368,20.712 c5.205-0.432,9.781,3.446,10.207,8.659c0.428,5.209-3.448,9.781-8.659,10.207 C1482.26,1648.439,1480.684,1648.502,1479.112,1648.502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M1481.23,1462.743c-3.663,0-7.151-2.139-8.696-5.718c-9.109-21.11-5.392-47.173,9.251-64.853 c3.335-4.029,9.301-4.589,13.327-1.252c4.026,3.333,4.587,9.301,1.252,13.327c-10.218,12.34-12.81,30.535-6.446,45.277 c2.07,4.8-0.141,10.37-4.942,12.442C1483.754,1462.493,1482.482,1462.743,1481.23,1462.743z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6F3737"
    },
    d: "M1171.907,1529.8c0.738-16.085-2.214-34.66-5.852-50.345c-0.54-2.329-3.984-1.965-4.035,0.425 c-0.402,18.828-2.403,50.088-11.001,60.687c-12.613,15.55,19.428-13.157,19.428-13.157L1171.907,1529.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9FB3CC"
    },
    d: "M1584.161,1816.596c-6.624-6.517-24.797-18.964-56.597-16.841 c-68.372,4.565-239.232,46.817-241.649,47.458c59.574-22.128,200.481-62.559,219.297-72.905 c14.203-7.807,52.455-82.87,70.914-120.231c-1.754,27.129,0.214,61.003,1.005,80.667c0.036,0.884,0.093,1.982,0.178,3.273 c0.029,0.428,0.057,0.884,0.086,1.355c0.442,6.652,1.34,17.468,2.531,30.901c0.071,0.877,0.15,1.761,0.228,2.652 c0.135,1.512,0.271,3.059,0.413,4.634c0.228,2.545,0.464,5.169,0.713,7.857 C1582.157,1795.092,1583.127,1805.616,1584.161,1816.596z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6ADA1"
    },
    d: "M1397.465,1217.649c0,0,0,49.097-8.357,68.945l3.134,54.321c0,0-5.557,13.037-24.214,24.402 c-18.964,11.508-51.487,21.257-105.47,13.758c-6.112-0.849-11.03-5.455-12.185-11.517l-14.825-77.83l-18.803-29.25 c0,0-21.937,16.714-36.562-8.357c-14.625-25.071-16.714-47.008,5.223-49.097c0,0,20.893-53.276,90.882-73.124 c69.99-19.848,99.24-1.045,103.418,10.446c4.179,11.491,4.179,11.491,4.179,11.491s19.848-6.268,24.026,12.535 C1412.09,1183.176,1416.268,1212.425,1397.465,1217.649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#613532"
    },
    d: "M1394.373,1151.064c0,0-23.671,18.406-43.916-6.539c0,0-50.142,29.25-105.507,14.625 c0,0-6.644,48.053-47.384,60.588c0,0-8.524-17.278-12.16-16.714c-3.614,0.585-7.73,1.964-7.73,1.964s-1.859-6.623-3.719-16.651 c-3.99-21.519-8.023-58.666,6.226-79.329c16.234-23.504,34.995-55.24,81.105-52.064c4.45,0.292,9.172,0.919,14.165,1.922 c42.098-28.205,82.985,2.758,96.293,21.937C1385.076,1100.003,1394.373,1151.064,1394.373,1151.064z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#613532"
    },
    d: "M1247.359,1233.681c-1.881,0.357-3.851-0.541-4.773-2.331c-1.123-2.18-0.267-4.859,1.914-5.983 c7.371-3.798,14.903-7.102,22.186-10.298c7.163-3.142,14.006-7.234,21.133-10.907c2.178-1.128,5.422,0.575,6.545,2.756 c1.123,2.18,0.268,4.858-1.914,5.983c-7.373,3.801-14.908,7.106-22.195,10.303c-7.159,3.14-14.562,6.388-21.686,10.059 C1248.178,1233.465,1247.77,1233.603,1247.359,1233.681z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#613532"
    },
    d: "M1322.949,1211.671c-1.841,0.032-3.581-1.09-4.25-2.916c-0.842-2.304-0.069-5.736,2.234-6.579 l41.819-13.154c2.311-0.845,4.098-0.487,4.941,1.816c0.842,2.304-0.343,4.855-2.647,5.698l-40.649,14.865 C1323.919,1211.575,1323.43,1211.662,1322.949,1211.671z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AF746C"
    },
    d: "M1392.242,1340.914c0,0-5.557,13.037-24.214,24.402c-10.823,1.149-32.331,11.318-50.716,7.787 c-27.286-5.223-42.319-38.791-42.319-38.791c14.312,5.766,24.006,11.533,39.362,13.183c15.335,1.63,34.876-1.735,47.6-10.489 c18.135-12.473,26.652-34.973,27.154-50.413L1392.242,1340.914z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#613532"
    },
    d: "M1294.119,1184.93c-20.699,0-41.1-10.748-52.651-27.965l1.734-1.165 c11.728,17.48,32.883,28.061,53.908,26.962l0.11,2.087C1296.186,1184.904,1295.153,1184.93,1294.119,1184.93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#613532"
    },
    d: "M1276.152,1069.798l-1.579-3.108c-4.375-8.614-20.265-18.688-30.506-17.203l-0.302-2.067 c10.228-1.484,25.034,7.189,31.164,15.851c2.36-10.99,11.008-20.448,21.861-23.547l0.573,2.01 c-10.981,3.135-19.543,13.251-20.82,24.6L1276.152,1069.798z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.52,
      fill: "#CD665D"
    },
    cx: 1267.139,
    cy: 1270.146,
    rx: 24.749,
    ry: 16.448
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.866 -0.5 0.5 0.866 -436.7798 851.1437)",
    style: {
      opacity: 0.52,
      fill: "#CD665D"
    },
    cx: 1369.856,
    cy: 1240.609,
    rx: 24.749,
    ry: 16.448
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.11,
      fill: "#FFFFFF"
    },
    d: "M1253.495,1101.173c-9.443,4.701-20.203,5.808-30.712,6.811 c2.736,32.237-16.275,65.185-45.546,78.974c-1.045,0.501-2.152,0.961-3.28,1.379c-3.99-21.519-8.023-58.666,6.226-79.329 c16.234-23.504,34.995-55.24,81.105-52.064C1273.802,1068.518,1273.364,1091.312,1253.495,1101.173z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AF746C"
    },
    d: "M1322.792,1260.098c-0.435,0-0.866-0.066-1.284-0.199c-0.779-0.249-1.209-1.081-0.961-1.861 c0.249-0.778,1.078-1.214,1.861-0.961c0.483,0.152,0.949-0.021,1.255-0.196c0.704-0.402,1.276-1.179,1.459-1.981 c0.361-1.586-0.152-3.306-0.861-5.391l-8.112-23.839c-0.263-0.773,0.151-1.615,0.925-1.878c0.768-0.266,1.615,0.151,1.878,0.925 l8.112,23.838c0.677,1.992,1.521,4.471,0.945,7.002c-0.364,1.597-1.466,3.089-2.877,3.895 C1324.383,1259.881,1323.581,1260.098,1322.792,1260.098z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#613532"
    },
    d: "M1266.967,1244.667c-1.551,0-3.037-0.108-4.417-0.348c-0.806-0.14-1.346-0.907-1.206-1.712 c0.14-0.807,0.905-1.351,1.712-1.206c7.745,1.341,19.701-2.017,25.356-4.709c0.736-0.352,1.621-0.039,1.973,0.7 c0.352,0.739,0.039,1.622-0.7,1.973C1284.518,1241.827,1274.918,1244.667,1266.967,1244.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#613532"
    },
    d: "M1334.744,1227.371c-0.753,0-1.397-0.571-1.471-1.336c-0.08-0.814,0.515-1.538,1.329-1.617 c8.603-0.84,18.68-4.769,23.438-9.141c0.6-0.552,1.54-0.513,2.091,0.089c0.555,0.602,0.514,1.538-0.088,2.092 c-5.258,4.833-15.837,8.999-25.154,9.907C1334.84,1227.369,1334.792,1227.371,1334.744,1227.371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AF746C"
    },
    d: "M1343.837,1276.732c2.386,0.004,4.816,0.114,7.283,0.334c0.814,0.073,1.416,0.792,1.343,1.607 c-0.072,0.815-0.792,1.422-1.607,1.343c-16.392-1.464-31.64,2.293-41.826,10.301c-0.641,0.503-1.574,0.396-2.079-0.248 c-0.505-0.642-0.394-1.574,0.25-2.079C1316.58,1280.614,1329.398,1276.71,1343.837,1276.732z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AF746C"
    },
    d: "M1323.364,1295.757c-0.818,0-1.48-0.662-1.48-1.48c0-0.818,0.662-1.48,1.48-1.48 c5.452,0,11.329-1.98,15.299-3.642c0.747-0.313,1.622,0.039,1.936,0.795c0.316,0.754-0.039,1.621-0.794,1.937 C1335.585,1293.653,1329.307,1295.757,1323.364,1295.757z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.51,
      fill: "#512B19"
    },
    d: "M1393.118,1173.954c-1.347-5.504,2.242-11.725,7.68-13.314l0.588,2.006 c-4.417,1.289-7.333,6.342-6.239,10.813L1393.118,1173.954z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AF746C"
    },
    d: "M1189.431,1226.099l-0.034,0.011c-0.495,0.236-1.069,0.022-1.339-0.462 c-1.609-2.881-4.255-5.223-7.316-6.461c-1.891,7.361-0.664,15.409,3.298,21.892c0.281,0.473,0.169,1.081-0.293,1.384 l-0.045,0.034c-0.473,0.315-1.137,0.18-1.429-0.304c-4.288-6.99-5.583-15.657-3.545-23.592c0-0.011,0.011-0.023,0.011-0.034 c-0.855-0.169-1.576-0.135-2.184,0.079c-0.608,0.214-1.193,0.788-1.328,1.396c-0.09,0.371-0.417,0.63-0.777,0.72h-0.011 c-0.754,0.191-1.43-0.518-1.227-1.272c0.338-1.306,1.441-2.386,2.634-2.814c1.306-0.473,2.837-0.405,4.694,0.203 c3.917,1.294,7.35,4.153,9.353,7.778C1190.185,1225.177,1189.982,1225.84,1189.431,1226.099z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.51,
      fill: "#512B19"
    },
    d: "M1403.768,1187.466l-2.057-0.38c1.363-7.38-1.026-15.32-6.237-20.723l1.506-1.451 C1402.648,1170.793,1405.25,1179.435,1403.768,1187.466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#613532"
    },
    d: "M1275.467,1249.461c-0.873,0-1.774-0.039-2.698-0.119c-0.814-0.071-1.417-0.789-1.347-1.604 c0.07-0.816,0.791-1.427,1.604-1.347c5.099,0.442,9.437-0.497,11.6-2.516c0.595-0.557,1.534-0.527,2.092,0.072 c0.558,0.597,0.525,1.534-0.073,2.092C1284.27,1248.259,1280.281,1249.461,1275.467,1249.461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#613532"
    },
    d: "M1344.117,1230.271c-0.065,0-0.131,0-0.194-0.001c-0.818-0.007-1.475-0.675-1.469-1.494 c0.008-0.817,0.728-1.529,1.494-1.467c4.389,0.04,7.89-1.422,9.659-4.01c0.463-0.674,1.381-0.847,2.059-0.387 c0.673,0.462,0.847,1.383,0.386,2.058C1353.743,1228.345,1349.399,1230.271,1344.117,1230.271z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6ADA1"
    },
    d: "M1132.767,1743.899c0,0-29.036-16.592-34.843-18.251c-5.807-1.659-19.91-1.659-25.718-5.807 c-5.807-4.148-11.614,9.955-4.978,16.592c6.637,6.637,20.74,13.274,20.74,24.058c0,10.785-5.807,14.933-4.148,20.74 c1.659,5.807,0,19.911,0,25.718c0,5.807,0.83,14.103,5.807,18.251c4.978,4.148,5.807,19.91,12.444,24.058 c6.637,4.148,22.399,8.296,30.695,10.785c8.296,2.489,18.251,0,18.251,0s-15.38-40.605-20.358-61.345 C1125.683,1777.958,1132.767,1743.899,1132.767,1743.899z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1252.878,1832.936l-94.96,25.26l-3.02,0.82l-3.87,1.02c-16.77-21.14-22.82-44.59-24.12-64.85 c-0.22-3.4-0.31-6.71-0.29-9.91c0.09-16.95,3.14-30.64,4.9-37.19c0-0.01,0.01-0.01,0.01-0.01c0.73-2.7,1.24-4.18,1.24-4.18 l3-0.84c0.01-0.01,0.01-0.01,0.01-0.01l5.58-1.57l3.53-0.99l24.17-6.79l58.33-14.6L1252.878,1832.936z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9FB3CC"
    },
    d: "M1382.596,1642.966c12.746-4.789,30.139-6.748,41.575,1.915c0.653,0.494,0.779,1.422,0.286,2.074 c-0.488,0.652-1.418,0.782-2.073,0.287c-9.465-7.172-24.883-5.852-36.646-2.194c1.961,0.666,3.862,1.087,5.835,1.521 c6.362,1.402,15.181,3.78,21.732,13.506c1.767,2.623,2.421,13.971,2.419,14.092c-0.018,0.807-0.677,1.449-1.481,1.449h-0.031 c-0.813,0-1.47-0.662-1.451-1.476c0.035-1.556-0.053-3.975-0.235-6.295c-0.318-4.041-2.178-7.807-5.204-10.505 c-6.363-5.671-11.256-6.749-16.387-7.881c-3.156-0.696-6.617-1.744-10.224-3.556L1382.596,1642.966z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9FB3CC"
    },
    d: "M1166.146,1862.523c-0.791,0-1.447-0.624-1.478-1.421c-0.033-0.817,0.603-1.506,1.42-1.538 c6.667-0.268,13.624-0.396,20.354-0.518c19.817-0.362,40.31-0.735,57.724-4.688c0.802-0.188,1.59,0.319,1.771,1.116 c0.182,0.797-0.318,1.59-1.116,1.771c-17.71,4.019-38.357,4.397-58.325,4.761c-6.714,0.122-13.656,0.25-20.29,0.516 C1166.187,1862.523,1166.166,1862.523,1166.146,1862.523z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCDAEB"
    },
    d: "M1157.922,1858.199l-3.029,0.815c-22.899-34.306-28.059-78.932-13.539-117.541l3.531-0.982 c-0.021,0.083-0.063,0.167-0.084,0.25C1129.905,1778.599,1135.086,1824.541,1157.922,1858.199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCDAEB"
    },
    d: "M1597.877,1961.241c-72.101,27.766-154.082,42.14-243.628,42.746 c-1.943,0.021-3.907,0.021-5.871,0.021c-73.896,0-155.001-9.297-241.267-27.662c0.021-0.961,0.084-1.943,0.146-2.967 c0.063,0,0.146,0,0.229,0.021c88.417,18.845,171.402,28.163,246.741,27.62c89.357-0.585,171.109-14.959,242.98-42.684 c0.146-0.042,0.271-0.083,0.397-0.083C1597.689,1959.298,1597.772,1960.28,1597.877,1961.241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9FB3CC"
    },
    d: "M1506.695,1436.557c-0.112,0-0.224-0.013-0.337-0.039c-0.798-0.186-1.294-0.981-1.108-1.778 c4.382-18.846,24.257-32.414,43.405-29.61c0.808,0.118,1.369,0.87,1.251,1.679c-0.118,0.81-0.865,1.367-1.679,1.251 c-17.665-2.572-36.044,9.941-40.092,27.351C1507.976,1436.094,1507.366,1436.557,1506.695,1436.557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9FB3CC"
    },
    d: "M1511.206,1418.464c-0.041,0-0.08-0.001-0.12-0.004c-0.814-0.065-1.422-0.779-1.357-1.594 c2.099-26.263,13.545-42.5,32.23-45.724c0.79-0.143,1.571,0.401,1.71,1.207c0.139,0.806-0.402,1.572-1.208,1.711 c-23.237,4.009-28.633,28.688-29.782,43.043C1512.618,1417.877,1511.969,1418.464,1511.206,1418.464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCDAEB"
    },
    d: "M1406.731,1357.948c-7.041,12.034-20.14,18.552-30.754,22.919 c-23.922,9.799-49.661,14.75-75.443,14.75c-16.693,0-33.407-2.089-49.62-6.268c-5.015-1.295-10.655-3.05-14.333-7.459 c-1.985-2.319-3.008-5.62-2.779-8.712c1.045-0.334,2.089-0.69,3.134-1.045c-0.041,0.23-0.083,0.46-0.125,0.71 c-0.334,2.486,0.46,5.286,2.026,7.145c3.134,3.74,8.252,5.307,12.828,6.477c40.615,10.53,84.385,7.563,123.183-8.357 c10.195-4.158,22.752-10.404,29.333-21.666c4.994-8.587,4.701-20.328-0.689-27.369c-0.209-0.229-0.335-0.522-0.355-0.856 c1.045-0.105,2.11-0.188,3.176-0.292C1412.038,1336.032,1412.247,1348.463,1406.731,1357.948z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9FB3CC"
    },
    d: "M1227.39,1720.108c-0.453,0-0.865-0.306-0.98-0.766c-0.136-0.541,0.194-1.09,0.735-1.225 c30.045-7.522,68.129-24.463,94.786-37.35c28.908-13.974,50.982-26.327,51.201-26.45c0.487-0.273,1.102-0.101,1.376,0.387 c0.273,0.487,0.1,1.103-0.387,1.376c-0.22,0.123-22.338,12.501-51.299,26.501c-26.746,12.93-64.972,29.931-95.187,37.496 C1227.553,1720.098,1227.471,1720.108,1227.39,1720.108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9FB3CC"
    },
    d: "M1380.872,1645.891c-0.21,0-0.422-0.066-0.604-0.201c-0.447-0.334-0.54-0.967-0.205-1.414 c21.752-29.16,50.658-76.586,71.076-111.238c22.13-37.556,39.331-68.607,39.502-68.916c0.271-0.489,0.885-0.663,1.374-0.395 c0.488,0.271,0.665,0.885,0.395,1.374c-0.171,0.309-17.385,31.384-39.529,68.963c-20.444,34.695-49.391,82.188-71.198,111.421 C1381.484,1645.751,1381.179,1645.891,1380.872,1645.891z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9FB3CC"
    },
    points: "1275.926,1584.772 1227.635,1720.077 1197.201,1726.653  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9FB3CC"
    },
    d: "M1227.388,1719.096c-22.07,45.73-40.53,60.91-53.59,66.81c-8.51,3.85-27.4,7.66-46.89,9.28 c-0.22-3.4-0.31-6.71-0.29-9.91c0.09-16.95,3.14-30.64,4.9-37.19c0-0.01,0.01-0.01,0.01-0.01c0.86-1.22,1.72-2.3,2.54-3.23 c0.55-0.62,1.12-1.22,1.7-1.79c0.01-0.01,0.01-0.01,0.01-0.01l5.58-1.57l3.53-0.99l24.17-6.79L1227.388,1719.096z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M1205.92,1445.488c0,0,8.406-5.93,16.438,2.444s80.35,88.361,71.819,104.022 c-8.531,15.661-47.571-27.886-47.571-27.886s-27.609-26.026-31.632-38.158C1210.951,1473.778,1205.92,1445.488,1205.92,1445.488z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6ADA1"
    },
    d: "M1402.714,1325.498c-0.124,2.645-1.439,5.418-2.191,13.041 c-1.802,18.277-2.435,39.568-13.849,51.691c-14.317,15.218-56.199,51.956-64.517,56.402 c-8.318,4.446-14.925,9.657-25.753,16.737c-6.686,4.345-19.765,31.291-28.871,51.371c-0.608,1.328-1.294,2.859-2.026,4.491 c-2.87,6.359-6.427,14.261-7.811,17.48c-7.125-6.461-19.056-20.936-29.681-32.349c-9.196-15.42-19.911-31.966-19.709-51.224 c0,0,25.201-34.071,26.158-41.139c0.99-7.069-4.311-33.193-3.557-46.531c0-16.94,3.185-33.441,2.758-50.133 c-0.045-1.79-0.045-3.737,1.036-5.166c2.116-2.836,6.686-1.722,9.489,0.428c7.44,5.695,7.834,14.542,9.354,22.995 c0.743,4.142,1.745,16.501,6.168,18.831c2.949,1.553,22.826-0.056,40.892-8.813c22.556-10.941,87.291-46.267,87.291-46.267 s16.596,3.574,5.718,19.469c-0.369,0.539,0.418,0.894,1.009,0.808C1398.872,1317.001,1402.973,1319.994,1402.714,1325.498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AF746C"
    },
    d: "M1400.049,1339.432c-0.02,0.017-0.044,0.033-0.068,0.049l-44.051,28.865 c-1.372,0.899-2.779,1.766-4.185,2.633c-4.853,2.992-9.869,6.087-13.386,10.534c-0.242,0.319-0.718,0.374-1.039,0.121 c-0.321-0.253-0.374-0.72-0.121-1.041c3.679-4.651,8.81-7.816,13.769-10.875c1.396-0.861,2.79-1.721,4.152-2.613l44.051-28.865 c0.342-0.224,0.8-0.128,1.025,0.213C1400.405,1338.774,1400.336,1339.193,1400.049,1339.432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AF746C"
    },
    d: "M1396.132,1369.15c-0.023,0.02-0.048,0.037-0.076,0.055 c-9.529,6.053-19.069,12.089-28.595,18.114c-8.037,5.087-16.352,10.348-22.278,17.938c-0.257,0.327-0.719,0.377-1.039,0.127 c-0.322-0.251-0.379-0.717-0.129-1.038c6.086-7.792,14.51-13.124,22.653-18.278c9.526-6.025,19.066-12.061,28.595-18.114 c0.344-0.218,0.802-0.116,1.021,0.228C1396.487,1368.501,1396.415,1368.916,1396.132,1369.15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AF746C"
    },
    d: "M1394.618,1317.625c-10.835,6.765-21.142,13.883-32.672,19.664 c-11.42,5.723-23.309,11.857-34.073,18.5c-0.379,0.238-0.868,0.122-1.106-0.257c-0.084-0.135-0.122-0.283-0.122-0.431 c0-0.27,0.135-0.534,0.386-0.688c10.828-6.681,22.673-12.622,34.132-18.365c11.658-5.851,21.67-13.22,32.614-20.03 C1393.904,1316.667,1394.207,1317.188,1394.618,1317.625z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.52,
      fill: "#7F413C"
    },
    d: "M1265.507,1519.23c-2.87,6.359-6.427,14.261-7.811,17.48 c-7.125-6.461-19.056-20.936-29.681-32.349c-9.196-15.42-19.911-31.966-19.709-51.224 C1208.306,1453.137,1225.809,1501.491,1265.507,1519.23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1294.182,1551.947c0,0-85.05,156.285-92.041,167.264c-6.978,10.995-14.139,32.507-38.93,47.876 c-24.805,15.352-64.264,3.128-70.884-3.602c-13.751-13.978-28.809-54.166-28.809-54.166c-5.966-24.417-7.431-60.92,13.26-89.514 c11.294-15.608,89.097-120.468,119.868-161.851c0.947-1.247,1.814-2.427,2.628-3.508c4.04-5.438,6.434-8.672,6.652-8.933 c0.406,1.373,13.929,47.641,30.561,64.791C1250.545,1524.808,1282.952,1564.295,1294.182,1551.947z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M1188.921,1665.459c-16.384,13.582-39.987,18.034-60.233,11.005 c-4.94-1.714-7.553-7.108-5.837-12.046c1.713-4.938,7.108-7.552,12.046-5.837c15.121,5.248,32.894,1.33,44.299-9.818 c3.724-3.632,9.731-3.591,13.385,0.152c3.654,3.737,3.588,9.731-0.152,13.385 C1191.302,1663.403,1190.131,1664.456,1188.921,1665.459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCDAEB"
    },
    d: "M1282.14,1569.011c0.74,0.337,1.075,1.198,0.752,1.955c-0.124,0.211-0.245,0.392-0.422,0.539 c-0.418,0.347-1.02,0.439-1.546,0.197c-35.892-16.191-78.392-66.281-84.28-113.748c0.947-1.247,1.814-2.427,2.628-3.508 C1203.459,1501.858,1246.206,1552.802,1282.14,1569.011z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AF746C"
    },
    d: "M1231.249,1362.176c-0.04,0-0.079-0.002-0.119-0.007c-0.548-0.065-0.94-0.563-0.875-1.111 c1.663-14.034,2.437-28.317,2.299-42.453c-0.024-2.433-0.073-7.496,3.429-9.671c2.034-1.262,4.882-1.162,7.258,0.255 c2.21,1.319,3.675,3.436,4.705,5.133c4.393,7.243,6.057,15.667,7.667,23.813c0.79,3.998,1.607,8.132,2.735,12.055 c0.192,0.667,0.38,1.249,0.734,1.623c0.542,0.573,1.537,0.716,2.531,0.786c14.122,0.994,27.607-5.588,39.504-11.395 c25.612-12.503,52.097-25.433,76.74-40.654l0.13-0.081c2.275-1.405,4.627-2.858,7.321-3.515c3.245-0.792,6.402-0.151,8.445,1.714 c2.58,2.355,4.151,5.982,4.31,9.951c0.184,4.553-2.208,8.417-7.106,11.483c-0.469,0.292-1.085,0.151-1.378-0.317 c-0.293-0.468-0.151-1.086,0.317-1.379c4.306-2.696,6.324-5.871,6.17-9.708c-0.136-3.388-1.504-6.586-3.661-8.554 c-1.824-1.666-4.618-1.738-6.623-1.247c-2.386,0.581-4.601,1.95-6.743,3.273l-0.13,0.081 c-24.728,15.273-51.257,28.225-76.914,40.75c-11.522,5.625-25.869,12.621-40.521,11.593c-1.332-0.093-2.83-0.333-3.844-1.407 c-0.717-0.759-1.009-1.773-1.203-2.444c-1.152-4.005-1.977-8.182-2.775-12.221c-1.576-7.976-3.206-16.223-7.415-23.163 c-0.909-1.499-2.188-3.36-4.019-4.453c-1.427-0.851-3.58-1.266-5.179-0.274c-2.238,1.39-2.516,4.644-2.484,7.953 c0.139,14.221-0.64,28.59-2.313,42.707C1232.18,1361.802,1231.749,1362.176,1231.249,1362.176z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "road_cone"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A4254"
    },
    d: "M2448.027,3175.57h-457.041l114.976-247.882l19.646-42.36l17.245-37.181l19.646-42.35l32.465-69.993 c5.015-10.812,15.384-16.03,25.569-15.654c9.5,0.347,18.836,5.556,23.514,15.654l32.465,69.993l19.646,42.35l17.245,37.181 l19.646,42.36l105.399,227.223L2448.027,3175.57z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EEBE58"
    },
    points: "2296.159,2848.146 2142.854,2848.146 2162.501,2805.796 2276.513,2805.796  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EEBE58"
    },
    points: "2333.051,2927.688 2105.963,2927.688 2125.609,2885.328 2313.404,2885.328  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.16,
      fill: "#FFFFFF"
    },
    d: "M2438.45,3154.911c-5.806,3.472-11.882,6.472-18.19,8.902 c-16.251,6.269-33.68,8.709-50.934,11.102c-1.572,0.222-3.154,0.434-4.726,0.656c-22.251,3.086-44.501,6.182-66.752,9.259 c1.109-0.154,1.862-3.598,2.344-9.259c2.382-27.796-1.688-109.103-2.228-118.159c-4.572-76.146-17.399-151.781-38.184-225.179 c-10.166-35.908-20.978-73.359-36.853-107.222c-0.781-1.659-1.582-3.279-2.392-4.861c9.5,0.347,18.836,5.556,23.514,15.654 l32.465,69.993l19.646,42.35l17.245,37.181l19.646,42.36L2438.45,3154.911z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1990.986,
    y: 3125.107,
    style: {
      fill: "#EEBE58"
    },
    width: 457.043,
    height: 50.46
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundPage);
export default __webpack_public_path__ + "static/media/NotFoundPage.60594045bfaceecb3d8090f8e8a93b22.svg";
export { ForwardRef as ReactComponent };